module.exports = __webpack_public_path__ + "images/help_v2/avatars/songhui-20c0504d6ed9b3ff1e923992e4eb0b71.png";